const translations = {
    fieldNameFieldLabel: 'Field Name'
};

export default translations;
